module.exports = __webpack_public_path__ + "static/media/mailIcon.06436501.svg";